import { useEffect, useState } from 'react';
import { Host } from '@wix/sdk';
import { createClientsForHosts } from '../services/spacingClientService';
import { DefaultClient } from '../../types';

export const useSpacingClients = (hosts: Host[]): DefaultClient[] => {
  const [clients, setClients] = useState<DefaultClient[]>([]);
  const [isClientsCreated, setIsClientsCreated] = useState(false);

  useEffect(() => {
    if (hosts.length > 0 && !isClientsCreated) {
      setClients(createClientsForHosts(hosts));
      setIsClientsCreated(true);
    }
  }, [hosts, isClientsCreated]);

  return clients;
};
